import { Component, OnInit, ChangeDetectionStrategy, Input, Renderer2, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { MatRadioButton } from '@angular/material/radio';
import { FormGroup, UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CriterioEvaluado } from '../models/criterio-evaluado';

@Component({
  selector: 'app-boton-criterio',
  standalone: false,
  templateUrl: './boton-criterio.component.html',
  styleUrls: ['../retroalimentacion.component.scss', './boton-criterio.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BotonCriterioComponent implements OnInit {

  @Input()
  criterioId: number;

  @Input()
  radio: MatRadioButton;

  @Input()
  radioForm: UntypedFormControl;

  @Input()
  label: string;

  @Input()
  criterioNombre: string;

  @Input()
  autoevaluacion: CriterioEvaluado[];

  @Input()
  urlImagen: string;

  @Input()
  mostrarAutoevaluacion: boolean;

  autoevaluacionCheck: boolean;

  checked$: Observable<boolean>;

  constructor() {
  }

  ngOnInit(): void {
    this.checked$ = this.radioForm.valueChanges.pipe(
      map(data => {
        return data.radio === this.criterioId;
      }),
      startWith(this.radio.checked)
    );
    if (this.autoevaluacion) {
      this.autoevaluacionCheck = this.autoevaluacion.findIndex(item => item.criterioId === this.criterioId) > -1;
    }
  }

  onClick() {
    if (this.radio.checked === true) {
      this.radioForm.setValue({radio: null, save: true});
    } else {
      this.radioForm.setValue({radio: this.criterioId, save: true});
    }
  }

}
